// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "@oddcamp/cocoon-vanilla-js"

let smoothScrollBound = false
const normalizePath = (path) => path.replace(/\/+$/, "") || "/"

const bindSmoothAnchorScroll = () => {
  if (smoothScrollBound) return
  smoothScrollBound = true

  document.addEventListener("click", (event) => {
    const clickedNode = event.target
    const clickedElement =
      clickedNode instanceof Element ? clickedNode : clickedNode?.parentElement
    if (!clickedElement) return

    const link = clickedElement.closest("a")
    if (!link) return

    if (link.hasAttribute("data-scroll-top")) {
      const targetUrl = new URL(link.href, window.location.origin)
      const currentPath = normalizePath(window.location.pathname)
      const targetPath = normalizePath(targetUrl.pathname)

      if (currentPath === targetPath) {
        event.preventDefault()
        window.scrollTo({ top: 0, behavior: "smooth" })
        history.replaceState(null, "", `${window.location.pathname}${window.location.search}`)
      }

      return
    }

    if (!link.matches('a[href^="#"]')) return

    const href = link.getAttribute("href")
    if (!href || href === "#") return

    const target = document.querySelector(href)
    if (!target) return

    event.preventDefault()
    target.scrollIntoView({ behavior: "smooth", block: "start" })
    history.pushState(null, "", href)
  })
}

bindSmoothAnchorScroll()
document.addEventListener("turbo:load", bindSmoothAnchorScroll)
